import ButtonComponent from '@qirapagos/web/src/components/atoms/Button'
import styled from 'styled-components'

export const Button = styled(ButtonComponent)`
  max-width: 300px !important;
  width: 45% !important;
  margin-top: 50px !important;
  margin-bottom: 50px !important;
`
